(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["legit-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initLH(scope){
    var root = (scope || document).querySelector('.lh');
    if(!root || root.dataset.lhReady === '1') return;
    root.dataset.lhReady = '1';
    var header = root.querySelector('.lh-header');

    if(root.classList.contains('lh--condense') && header){
      var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 24); };
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }

    if(root.classList.contains('lh--magnetic') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      Array.prototype.slice.call(root.querySelectorAll('.lh-mag')).forEach(function(el){
        el.addEventListener('mousemove', function(e){
          var r = el.getBoundingClientRect();
          var x = e.clientX - (r.left + r.width/2), y = e.clientY - (r.top + r.height/2);
          el.style.transform = 'translate(' + (x*0.32) + 'px,' + (y*0.32) + 'px)';
        });
        el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
      });
    }

    var burger = root.querySelector('.lh-burger');
    if(burger){
      var openDrawer = function(o){
        root.classList.toggle('lh--open', o);
        burger.setAttribute('aria-expanded', o ? 'true' : 'false');
        var d = root.querySelector('.lh-drawer');
        if(d) d.setAttribute('aria-hidden', o ? 'false' : 'true');
        document.body.style.overflow = o ? 'hidden' : '';
      };
      burger.addEventListener('click', function(){ openDrawer(!root.classList.contains('lh--open')); });
      Array.prototype.slice.call(root.querySelectorAll('[data-lh-close]')).forEach(function(el){
        el.addEventListener('click', function(){ openDrawer(false); });
      });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') openDrawer(false); });
    }

    // drawer accordion — works at any depth via nearest [data-lh-accgroup]
    Array.prototype.slice.call(root.querySelectorAll('[data-lh-acc]')).forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var group = btn.closest('[data-lh-accgroup]');
        if(!group) return;
        var open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ initLH(document); });
  document.addEventListener('shopify:section:load', function(e){ initLH(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
